import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { MomentModule } from 'angular2-moment';
import { MDBBootstrapModulePro } from 'libs/mdbootstrap/typescripts/pro/index';
import { MDBBootstrapModule } from 'libs/mdbootstrap/typescripts/free/index';
import { ProcessService } from 'app/core/process/process.service';
import { CoreModule } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { ModalModule } from 'app/modal/modal.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SearchProcessesRoutingModule } from 'app/searchProcesses/searchProcesses-routing.module';
import { SearchProcessesComponent } from 'app/searchProcesses/searchProcesses.component';

@NgModule({
  imports: [
    MDBBootstrapModule,
    MDBBootstrapModulePro,
    CommonModule,
    BrowserModule,
    TranslateModule,
    MomentModule,
    CoreModule,
    SharedModule,
    ModalModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    SearchProcessesRoutingModule
  ],
  declarations: [
    SearchProcessesComponent
  ],
  providers: [
    ProcessService
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class SearchProcessesModule { }



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/searchProcesses/searchProcesses.module.ts